<app-dashboard-layout [loading]="loading" [downloader]="downloader">
  <app-notification-alert [data]="notification"></app-notification-alert>

  <form class="flex flex-col mx-auto max-w-screen-md p-4 z-20 justify-center">
    <h1 class="font-medium text-center text-lg">
      Select a session & semester to print exam docket
    </h1>

    <!-- Skeleton Loader -->
    <section *ngIf="skeletonLoader">
      <div class="border rounded-md bg-gray-300 h-16 my-8 animate-pulse"></div>
      <div class="border rounded-md mx-auto max-w-md bg-gray-300 h-8 my-8 animate-pulse"></div>
    </section>

    <!-- Session/Semester Selection -->
    <section *ngIf="!skeletonLoader">
      <div class="py-8">
        <div class="bg-white border border-primary rounded-lg w-full p-2">
          <select
            name="session"
            [(ngModel)]="session"
            class="w-full p-2 focus:outline-none"
          >
            <option value="" disabled>Select a session</option>
            <option *ngFor="let session of sessions">{{ session }}</option>
          </select>
        </div>
      </div>

      <div class="pb-8">
        <div class="bg-white border border-primary rounded-lg w-full p-2">
          <select
            name="semester"
            [(ngModel)]="semester"
            class="w-full p-2 focus:outline-none"
          >
            <option value="" disabled>Select a semester</option>
            <option *ngFor="let semester of semesters">{{ semester }}</option>
          </select>
        </div>
      </div>

      <button
        [disabled]="loading || !session || !semester"
        (click)="proceedToSelection()"
        class="rounded cursor-pointer font-medium bg-primary/90 text-center text-white text-sm w-full py-2 px-4 uppercase whitespace-nowrap md:px-8 hover:bg-primary disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <span *ngIf="loading" class="animate-spin inline-block w-4 h-4 border-t-2 border-white rounded-full mr-2"></span>
        <span *ngIf="!loading">Continue</span>
      </button>
    </section>
  </form>
</app-dashboard-layout>